import { Group } from 'src/design/atoms/Group';
import { Stack } from 'src/design/atoms/Stack';
import { Title } from 'src/design/atoms/Title';
import { Drawer } from 'src/design/molecules/Drawer';
import { IconMessage } from '@tabler/icons-react';
import React from 'react';
import { TopicIssueDto } from 'src/api/FiretrolApiClient';
import { CommentValue } from './CommentValue';
import { NewComment } from './NewComment';

interface ICommentDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  issue: TopicIssueDto | null;
  jobId: number;
}

export const CommentDrawer: React.FC<ICommentDrawerProps> = ({
  isOpen,
  onClose,
  issue,
  jobId,
}) => (
  <Drawer
    opened={isOpen}
    onClose={onClose}
    position="right"
    size="md"
    title={
      <Group gap="xs">
        <IconMessage size={20} />
        <Title order={4}>Comments</Title>
      </Group>
    }
  >
    <Stack gap="md" mt="md">
      {(issue?.comments ?? []).map((comment) => (
        <CommentValue key={comment.id} comment={comment} />
      ))}
      <NewComment issue={issue} jobId={jobId} />
    </Stack>
  </Drawer>
);
